import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormOval: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-oval"><ellipse cx="11.75" cy="12" rx="9.5" ry="7.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFormOval;
